import type { MenuAccess, MenuItem, MenuLink } from './menu-types';

export type { MenuAccess } from './menu-types';

const isLinkVisible = (item: MenuLink, access: MenuAccess): boolean => {
  if (item.requiresLocation && !access.hasLocation) {
    return false;
  }

  if (item.module && !access.hasModule(item.module)) {
    return false;
  }

  return (
    (!item.permission || access.hasPermission(item.permission)) &&
    (!item.permissions || access.hasAnyPermission(item.permissions)) &&
    (!item.visibleWhen || item.visibleWhen(access))
  );
};

export const getVisibleMenuItems = (items: MenuItem[], access: MenuAccess): MenuItem[] => {
  return items.flatMap<MenuItem>((item) => {
    if (item.type === 'group') {
      if (item.module && !access.hasModule(item.module)) {
        return [];
      }

      if (item.permission && !access.hasPermission(item.permission)) {
        return [];
      }

      const visibleChildren = item.children.filter((child) => isLinkVisible(child, access));

      return visibleChildren.length > 0 ? [{ ...item, children: visibleChildren }] : [];
    }

    return isLinkVisible(item, access) ? [item] : [];
  });
};
